import React, { useEffect, useRef, useState } from 'react';

function prefixedMessage(prefix) {
  if (!prefix) return '';
  return prefix.endsWith('\n') ? prefix : `${prefix}\n`;
}

export default function ContactForm({
  compact = false,
  messagePrefix = '',
  idPrefix = 'contact',
  autoFocusMessage = false
}) {
  const [status, setStatus] = useState('');
  const [message, setMessage] = useState(() => prefixedMessage(messagePrefix));
  const messageRef = useRef(null);

  useEffect(() => {
    setMessage(prefixedMessage(messagePrefix));
  }, [messagePrefix]);

  useEffect(() => {
    if (!autoFocusMessage || !messageRef.current) return;
    const field = messageRef.current;
    field.focus();
    const end = field.value.length;
    field.setSelectionRange(end, end);
  }, [autoFocusMessage]);

  async function onSubmit(e) {
    e.preventDefault();
    const form = new FormData(e.currentTarget);
    const payload = Object.fromEntries(form.entries());
    setStatus('Sending...');
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 25000);
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        signal: controller.signal
      });
      clearTimeout(timeoutId);
      if (!res.ok) throw new Error('Request failed');
      setStatus('Thanks! I will get back to you soon.');
      e.currentTarget.reset();
      setMessage(prefixedMessage(messagePrefix));
    } catch (err) {
      if (err && (err.name === 'AbortError' || err.code === 20)) {
        setStatus('Request timed out. Please try again.');
      } else {
        setStatus('Something went wrong. Try again later.');
      }
    }
  }

  const nameId = `${idPrefix}-name`;
  const emailId = `${idPrefix}-email`;
  const messageId = `${idPrefix}-message`;

  return (
    <>
      <form onSubmit={onSubmit} className={`contact-form${compact ? ' contact-form-mini' : ''}`}>
        <div className={compact ? 'contact-form-mini-fields' : 'contact-form-fields'}>
          <div className="form-group">
            <label className="contact-label" htmlFor={nameId}>Name</label>
            <input id={nameId} name="name" required />
          </div>
          <div className="form-group">
            <label className="contact-label" htmlFor={emailId}>Email</label>
            <input id={emailId} name="email" type="email" required />
          </div>
        </div>
        <div className="form-group">
          <label className="contact-label" htmlFor={messageId}>Message</label>
          <textarea
            ref={messageRef}
            id={messageId}
            name="message"
            rows={compact ? 4 : 5}
            required
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>
        <button type="submit">Send</button>
      </form>
      {status && <div className="success-message" role="status">{status}</div>}
    </>
  );
}
